import { useState } from "react";
import {
  CalenderIcon,
  CalculatorIcon,
  Arrow,
  DeleteIcon,
  AddIcon,
} from "../../Images/svgs";
import DropDown from "../Partials/DropDown";
import { useDispatch, useSelector } from "react-redux";
import { toggleDropdown, setSelectedValue } from "../../Managment/Slice";

function GoldZaka() {
  const [startDate, setStartDate] = useState(null);
  const dispatch = useDispatch();
  const showlists = useSelector((state) => state.dropdown.showlists);
  const selectedValues = useSelector((state) => state.dropdown.selectedValues);

  const toggleDropDown = (index) => {
    dispatch(toggleDropdown({ index }));
  };

  const handleSelect = (value, index) => {
    dispatch(setSelectedValue({ index, value }));
  };

  const Gold = [
    { text: "عيار 14 قراط" },
    { text: "عيار 18 قيراط" },
    { text: "عيار 21 قيراط" },
    { text: "عيار 22 قيراط" },
    { text: "عيار 24 قيراط" },
  ];

  const year = [{ text: "ميلادي" }, { text: "هجري" }];

  return (
    <>
      <div className="justify-start w-full max-md:max-w-full">
        <div className="flex gap-5 max-md:flex-col max-md:gap-0 max-md:">
          <div className="flex flex-col ml-5 w-[67%] max-md:ml-0 max-md:w-full">
            <div className="flex flex-col grow self-stretch px-5 py-10 w-full bg-white rounded-2xl border border-solid border-black border-opacity-20 max-md:mt-5 max-md:max-w-full">
              <div className="self-start text-base font-medium whitespace-nowrap text-slate-700">
                اختر السنة
              </div>
              <div className="relative flex gap-2 justify-between px-3.5 py-2.5 mt-1.5 text-sm font-medium leading-6 text-right bg-white rounded-lg border border-gray-300 border-solid shadow-sm text-neutral-900 max-md:flex-wrap max-md:max-w-full">
                <input
                  className="outline-none grow max-md:max-w-full"
                  onClick={() => toggleDropDown(7)}
                  value={selectedValues[0]}
                  readOnly
                  placeholder="هجري"
                />
                <Arrow className="my-auto w-5 aspect-square" />
                <DropDown
                  links={year}
                  isOpen={showlists[7]}
                  onSelect={(value) => handleSelect(value, 0)}
                  dropdownId={7}
                />
              </div>
              <div className="flex gap-2 justify-between px-3.5 py-2.5 mt-5 text-sm leading-6 text-right rounded-lg border border-gray-300 border-solid shadow-sm bg-stone-50 max-md:flex-wrap max-md:max-w-full">
                <div className="grow text-gray-500 max-md:max-w-full">
                  نسبة الزكاة حسب السنة التي قمت بإختيارها
                </div>
                <div className="font-bold text-blue-900">
                  {selectedValues[0] === "ميلادي" ? "0.0275%" : "2.5%"}
                </div>
              </div>
              <div className="self-start mt-5 text-base font-medium whitespace-nowrap text-slate-700">
                قم باضافة الذهب
              </div>
              <div className="flex gap-1.5 justify-start mt-4 text-sm font-bold leading-6 text-right whitespace-nowrap flex-wrap text-neutral-900 max-md:flex-wrap max-md:max-w-full">
                <div className="relative grow flex gap-2 justify-between px-3.5 py-2.5 bg-white rounded-lg border border-gray-300 border-solid shadow-sm">
                  <input
                    className="grow text-right outline-none"
                    onClick={() => toggleDropDown(3)}
                    placeholder="اختر عيار الذهب"
                    value={selectedValues[3]}
                    readOnly
                  />
                  <Arrow />
                  <DropDown
                    links={Gold}
                    isOpen={showlists[3]}
                    onSelect={(value) => handleSelect(value, 3)}
                    dropdownId={3}
                  />
                </div>
                <input
                  className="grow justify-center px-3.5 py-2.5 text-black outline-none bg-white rounded-lg border border-gray-300 border-solid shadow-sm"
                  placeholder="الوزن بالغرام"
                />

                <DeleteIcon className="w-11 aspect-square" />
              </div>
              <button className="mt-4 flex items-center justify-center">
                <AddIcon className="w-auto h-6 sm:h-8 aspect-square" />
              </button>

              <div className="flex gap-2 justify-between px-3.5 py-2.5 mt-5 text-sm leading-6 text-right rounded-lg border border-gray-300 border-solid shadow-sm bg-stone-50 max-md:flex-wrap max-md:max-w-full">
                <div className="grow text-gray-500 max-md:max-w-full">
                  سعر الذهب عيار 24 اليوم هو
                </div>
                <div className="font-bold text-blue-900 whitespace-nowrap">
                  248 ر.س
                </div>
              </div>
              <button className="justify-center self-start px-3.5 py-2 mt-10 text-sm font-medium leading-5 whitespace-nowrap bg-amber-300 rounded-lg shadow-sm text-neutral-900">
                احسب قيمة الزكاة
              </button>
            </div>
          </div>
          <div className="flex flex-col w-[33%] max-md:ml-0 max-md:w-full">
            <div className="flex flex-col px-5 py-10 mx-auto w-full rounded-2xl border border-solid bg-emerald-300 bg-opacity-20 border-[color:var(--Main-Colors-4,#54E8B2)] max-md:mt-5">
              <CalculatorIcon className="self-start aspect-square w-[54px]" />
              <div className="mt-3 text-sm font-bold leading-6 text-right whitespace-nowrap text-neutral-900">
                قيمة الزكاة المراد اخراجها هي
              </div>
              <div className="mt-3 text-2xl font-bold leading-5 text-right text-black whitespace-nowrap">
                565 دينار
              </div>
              <div className="flex gap-3 pl-20 mt-10 max-md:pl-5">
                <button className="justify-center px-3.5 py-2 text-sm font-medium leading-5 whitespace-nowrap bg-amber-300 rounded-lg shadow-sm text-neutral-900">
                  اخرج زكاتك الان
                </button>
                <button className="flex justify-center items-center px-3.5 py-2 bg-blue-600 rounded-lg shadow-sm aspect-[1.33]">
                  <CalenderIcon className="w-5 aspect-square" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default GoldZaka;
